import { put } from 'redux-saga/effects';
import { userSignOut } from 'appRedux/actions/Auth';
import { UpdateRatePayload } from 'appRedux/reducers/chargeSchedule/chargeType';
import { ApiResponse } from 'constants/ActionTypes';
import { APIPostRequest } from 'util/connection';

type RateUpdateRpcResult = {
  result_code?: string;
  result_msg?: string;
  msg_code?: string;
};

type RateUpdateExecution = {
  success: boolean;
  result: RateUpdateRpcResult;
};

export function* executeRateUpdateRequests(
  endpoint: string,
  requests: UpdateRatePayload[],
  headers: unknown
): Generator<unknown, RateUpdateExecution, ApiResponse> {
  let result: RateUpdateRpcResult = {};
  let success = requests.length > 0;

  for (const request of requests) {
    const response: ApiResponse = yield APIPostRequest(endpoint, request, headers);
    result = response.data || {};
    success = response.status === 200 && result.result_code === '0';

    if (response.status === 403 && response.data?.data) yield put(userSignOut());
    if (!success) break;
  }

  return { success, result };
}
